import { FC } from "react";

interface FileIconProps {
  fileName?: string;
}

const types: Map<string, string> = new Map([
  ["xlsx", "xls"],
  ["xls", "xls"],
  ["csv", "xls"],
  ["docx", "doc"],
  ["doct", "doc"],
  ["doc", "doc"],
  ["pdf", "pdf"],
  ["png", "img"],
  ["jpg", "img"],
  ["gif", "img"],
  ["jpeg", "img"],
  ["tif", "img"],
  ["zip", "zip"],
  ["rar", "zip"],
  ["mp3", "audio"],
  ["mp4", "video"],
  ["avi", "video"],
  ["svg", "svg"],
]);

const FileIcon: FC<FileIconProps> = ({ fileName }: FileIconProps) => {
  const extension = fileName?.substring(fileName.lastIndexOf(".") + 1).toLowerCase() || "";
  const type = types.get(extension);

  return <img src={window.location.origin + `/${type ?? "generic"}.svg`} />;
};

export default FileIcon;
